import React from "react";
import SettingsNew from "@/pages/SettingsNew";

export default function SettingsPage() {
  return (
    <div className="space-y-4 sm:space-y-6 relative z-10 bg-white rounded-lg p-5 shadow-sm border border-gray-200">
      <SettingsNew />
    </div>
  );
}
